import {computed} from 'vue'

/**
 * Timezone detection composable
 */
export function useTimezoneDetection() {

  //Determine timezone
  const browserTimezone = computed(() => Intl.DateTimeFormat().resolvedOptions().timeZone)

  //Expose interface
  return {
    browserTimezone,
  }
}
